<template>
  <div class="foot-bg">

    <div class="index-footer">

      <div class="beian" v-if="!isMobile">
		    <div>
          <span class="copy-box">{{ companyName }} 版权所有</span>
          <a class="icp-box" href="https://beian.miit.gov.cn/" target="_blank"> {{ record }} </a>
          <span class="copy-box">&nbsp;&nbsp;&nbsp;&nbsp;办公地址：深圳市罗湖区笋岗街道笋西社区宝安北路1007号笋岗七号仓四层401-02单元&nbsp;&nbsp;&nbsp;&nbsp;联系电话：0755-25575809</span>
        </div>
      </div>

      <div v-else class="beian flex-column-center">
		    <div><span class="copy-box">{{ companyName }} 版权所有</span> </div>

		    <div><a class="icp-box" href="https://beian.miit.gov.cn/" target="_blank"> {{ record }} </a></div>
        <div><span class="copy-box">办公地址：深圳市罗湖区笋岗街道笋西社区宝安北路1007号笋岗七号仓四层401-02单元&nbsp;&nbsp;联系电话：0755-25575809</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "site-footer",
  data() {
	  return {
		  companyName : '深圳市致远速联信息技术有限公司',
		  record: '粤ICP备13055653号',

      isMobile: false
	  }
  },
  methods : {
	  setRecord(hostname) {
		const records = {
			"cmdp.cn" 			: '粤ICP备13055653号-5',
			"cmdinfo.cn" 		: '粤ICP备13055653号-6',
			"genesysinfo.net" 	: '粤ICP备13055653号',
		}

		if(hostname.indexOf('localhost') == -1) {
			const key = hostname.split('.').slice(1).join('.')
			this.record = records[key]
		}
	  }

  },
  created() {
	   this.setRecord(location.hostname)

  }
}
</script>

<style lang="less" scoped>
// @import "~@/assets/default.less";

.foot-bg {
  // background-image: url('../../../../src/assets/img/def/index/foot-bg.png');
  position: relative;
  // bottom: 0;
  // left: 50%;
  // transform: translateX(-50%);
  width: 100%;
  height: 40px;
  min-width: 800px;
  box-sizing: border-box;
  // background-color: linear-gradient(-45deg, rgba(63, 137, 196, 0.3), rgba(63, 137, 196, 0.1));
  background-color: #010e31;
  padding: 8px 0;

}

.index-footer {
  // border-top: 1px solid #ededed;
  // max-width: #page-size[normal-width];

  // margin-left: auto;
  // margin-right: auto;
}

.beian{
  padding: 0px 0;
  text-align: center;
  // background-color: red;
}
.copy-box,.icp-box {
  font-size: 12px;
  font-weight: 500;
  color: #a4a6ab;
}
</style>
